import Wow from "../utils/Wow";

class Tab {
  constructor(element) {
    this.main = element;

    this._id = this.main.dataset.tabId;
    this._anchorActiveClass = this.main.dataset.tabAnchorActiveClass;
    this._anchorInactiveClass = this.main.dataset.tabAnchorInactiveClass;
    this._anchors = this.main.querySelectorAll('[data-tab-anchor]');

    this._anchors.forEach(anchor =>
      anchor.addEventListener('click', this._onClickAnchor.bind(this))
    );
  }

  _onClickAnchor(e) {
    e.preventDefault();

    // Update btn/anchor
    const anchor = e.target;
    this._anchors.forEach(anchor => {
      if (anchor === e.target) {
        anchor.classList.add(this._anchorActiveClass);
        anchor.classList.remove(this._anchorInactiveClass)
      } else {
        anchor.classList.add(this._anchorInactiveClass);
        anchor.classList.remove(this._anchorActiveClass)
      }
    });

    // Update content
    const anchorId = anchor.dataset.tabAnchor;
    const contents = document.querySelectorAll(`[data-tab-name="${this._id}"]`);
    contents.forEach(content => content.classList.add('d-none'));
    const content = document.querySelector(
      `[data-tab-name="${this._id}"][data-tab-id="${anchorId}"]`
    );
    content.classList.remove('d-none');

    setTimeout(() => {
      Wow.sync();
    }, 50);
  }
}

export default Tab;
